// extracted by mini-css-extract-plugin
export default {"container":"Slides_container__YYruz"};